import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import DataTable, { Column } from '../../components/DataTable';
import { adminApi } from '../../services/admin';
import type { OrganizationDetail } from '../../types';

const columns: Column<OrganizationDetail>[] = [
  { key: 'name', header: 'Name' },
  { key: 'city', header: 'City', render: (r) => r.city || '—' },
  { key: 'state', header: 'State', render: (r) => r.state || '—' },
  { key: 'member_count', header: 'Members' },
  { key: 'created_at', header: 'Created', render: (r) => new Date(r.created_at).toLocaleDateString() },
];

export default function AdminClients() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'clients', page, search],
    queryFn: () => adminApi.getClients({ page: String(page), search: search || undefined }),
  });

  const totalPages = data ? Math.ceil(data.count / 20) : 1;

  return (
    <>
      <PageHeader title="Clients" description="All client organizations" />
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search clients..."
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          className="w-full sm:w-80 rounded-xl border-2 border-slate-200 px-4 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
        />
      </div>
      <DataTable
        columns={columns}
        data={data?.results ?? []}
        keyExtractor={(r) => r.id}
        isLoading={isLoading}
        emptyTitle="No clients"
        page={page}
        totalPages={totalPages}
        onPageChange={setPage}
        onRowClick={(r) => navigate(`/admin/clients/${r.id}`)}
      />
    </>
  );
}
